import { useState } from "react";
import { useNavigate } from "react-router-dom";

import { CatalogueView } from "./CatalogueView";
import { KickstartView } from "./KickstartView";
import type { GenieTemplate } from "./data";

// Real surface for the Genie Templates catalogue. Reached from the Set Up a
// Genie screen via the "Browse Genies" card on SetupModeSelector. Click a
// template -> Kickstart screen -> /user-hub/genie-setup?template=<slug>
// which preloads the full template via useTemplatePreload.ts.
const GenieTemplatesPage = () => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState<GenieTemplate | null>(null);

  const pickTemplate = (template: GenieTemplate) => setSelected(template);
  const backToCatalogue = () => setSelected(null);
  const backToSetup = () => navigate("/user-hub/genie-setup");

  if (selected) {
    return (
      <KickstartView
        template={selected}
        onBack={backToCatalogue}
        onDone={backToCatalogue}
      />
    );
  }

  return <CatalogueView onBack={backToSetup} onPick={pickTemplate} />;
};

export default GenieTemplatesPage;
